import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

const LockIcon = ({ color = '#B5BCBD', size = 14, ...props }) => (
  <svg
    width={size}
    viewBox="0 0 8 10"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.026 4.069H6.74l-.002-1.368C6.736 1.211 5.465-.001 3.904 0 2.34.001 1.07 1.214 1.072 2.703l.002 1.368H.97C.435 4.073 0 4.488 0 5v4.072c0 .512.437.928.974.928l6.055-.003c.536 0 .972-.416.971-.928V4.996c0-.512-.437-.927-.974-.927zm-4.908.002l-.003-1.367c0-.941.802-1.707 1.789-1.708.986 0 1.789.765 1.789 1.705l.002 1.368-3.577.002z"
      fill={color}
      fillRule="evenodd"
    />
  </svg>
);

LockIcon.propTypes = propTypes;

export default LockIcon;
